(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["claude-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlideshow(root) {
    var slides = Array.from(root.querySelectorAll('.claude-slideshow__slide'));
    var dots = Array.from(root.querySelectorAll('.claude-slideshow__dot'));
    var prevBtn = root.querySelector('.claude-slideshow__arrow--prev');
    var nextBtn = root.querySelector('.claude-slideshow__arrow--next');
    var pauseBtn = root.querySelector('.claude-slideshow__pause');
    var track = root.querySelector('.claude-slideshow__track');
    var current = 0;
    var total = slides.length;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var paused = false;
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (total < 2) return;

    /* NOTE: all slides share one grid cell (CSS grid-stack), so the track
       height is fixed to the tallest slide and never changes between slides.
       go() only toggles the active class (opacity + z-index). No height
       recalculation and no layout jump on slide change. */
    function go(index) {
      var next = ((index % total) + total) % total;
      slides[current].classList.remove('claude-slideshow__slide--active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('claude-slideshow__dot--active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      current = next;
      slides[current].classList.add('claude-slideshow__slide--active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('claude-slideshow__dot--active');
        dots[current].setAttribute('aria-selected', 'true');
      }
      if (autoplay && !paused) {
        clearInterval(timer);
        timer = setInterval(function () { go(current + 1); }, speed);
      }
    }

    function togglePause() {
      paused = !paused;
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      }
      if (track) {
        track.setAttribute('aria-live', paused ? 'polite' : 'off');
      }
      if (paused) {
        clearInterval(timer);
        timer = null;
      } else {
        timer = setInterval(function () { go(current + 1); }, speed);
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });
    if (pauseBtn) pauseBtn.addEventListener('click', togglePause);

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });

    if (autoplay && !reduced) {
      timer = setInterval(function () { go(current + 1); }, speed);
    }
  }

  function csInit(scope) {
    var root = scope || document;
    // The shopify:section:load event passes the section wrapper; the slideshow
    // root may be the wrapper itself or a descendant.
    if (root.matches && root.matches('[data-claude-slideshow]') && !root._csInit) {
      root._csInit = true;
      initSlideshow(root);
    }
    var els = root.querySelectorAll ? root.querySelectorAll('[data-claude-slideshow]') : [];
    for (var i = 0; i < els.length; i++) {
      if (!els[i]._csInit) {
        els[i]._csInit = true;
        initSlideshow(els[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { csInit(document); });
  } else {
    csInit(document);
  }

  // Theme editor: (re)initialize when a section is injected or reloaded so the
  // arrows, dots and keyboard nav work on the freshly rendered DOM.
  document.addEventListener('shopify:section:load', function (e) {
    csInit(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-overview-paint-stain"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    // IntersectionObserver reveal
    var revealEls = root.querySelectorAll('.gez-cov-ps__reveal');
    if (!revealEls.length) return;

    if (typeof IntersectionObserver === 'undefined') {
      for (var i = 0; i < revealEls.length; i++) {
        revealEls[i].classList.add('gez-cov-ps-in');
      }
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var e = 0; e < entries.length; e++) {
        if (entries[e].isIntersecting) {
          entries[e].target.classList.add('gez-cov-ps-in');
          observer.unobserve(entries[e].target);
        }
      }
    }, { threshold: 0.12 });

    for (var j = 0; j < revealEls.length; j++) {
      observer.observe(revealEls[j]);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('.gez-cov-ps');
    for (var i = 0; i < roots.length; i++) {
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-overview-stripper"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initReveal(root) {
    var reveals = root.querySelectorAll('.gez-cov-strip__reveal');
    if (!reveals.length) return;

    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('gez-cov-strip-in'); });
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('gez-cov-strip-in');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    reveals.forEach(function (el) { obs.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.gez-cov-strip[data-section-id]').forEach(function (section) {
      var wrapper = section.closest('[id^="shopify-section-"]');
      if (wrapper) initReveal(wrapper);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-chart-evolve"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(sectionId) {
    const suffix  = sectionId ? '-' + sectionId : '';
    const LS_KEY  = 'cc-favorites-evolve-v1'; // distinct from SD 'cc-favorites-v1'
    const FOREST  = '#2C3E2D';

    const dataEl = document.getElementById('ccev-color-data' + suffix);
    if (!dataEl) return;
    const COLORS = JSON.parse(dataEl.textContent);

    // ---- localStorage favorites ----
    function loadFavorites() {
      try { const r = localStorage.getItem(LS_KEY); return r ? JSON.parse(r) : []; }
      catch (_) { return []; }
    }
    function saveFavorites(arr) {
      try { localStorage.setItem(LS_KEY, JSON.stringify(arr)); } catch (_) {}
    }
    let favorites = loadFavorites();

    // ---- State ----
    let openColorSlug = null;
    let sourceCardEl  = null;

    // ---- Build card HTML (photo-driven — no hex line) ----
    function buildCardHTML(color) {
      const isFav    = favorites.includes(color.slug);
      const pressed  = isFav ? 'true' : 'false';
      const favLabel = isFav
        ? color.name + ' saved to favorites, click to remove'
        : 'Save ' + color.name + ' to favorites';
      return '<div class="ccev-card" role="listitem" tabindex="0"' +
        ' aria-label="' + color.name + ', ' + color.family + '"' +
        ' data-color-slug="' + color.slug + '"' +
        ' data-color-family="' + color.family + '"' +
        ' data-color-image="' + color.image + '">' +
        '<div class="ccev-card__inner">' +
        '<div class="ccev-card__swatch">' +
        '<img src="' + color.image + '" alt="' + color.name + ' soy stain on wood"' +
        ' width="300" height="214" loading="lazy" />' +
        '<span class="ccev-card__cat-badge">' + color.family + '</span>' +
        '</div>' +
        '<div class="ccev-card__body">' +
        '<div class="ccev-card__name">' + color.name + '</div>' +
        '</div></div>' +
        '<button class="ccev-card__heart" type="button" tabindex="0"' +
        ' aria-pressed="' + pressed + '" aria-label="' + favLabel + '"' +
        ' data-slug="' + color.slug + '" data-name="' + color.name + '">' +
        '<svg width="11" height="11" viewBox="0 0 24 24"' +
        ' fill="' + (isFav ? FOREST : 'none') + '"' +
        ' stroke="' + (isFav ? '#FFFFFF' : FOREST) + '"' +
        ' stroke-width="2" aria-hidden="true">' +
        '<path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>' +
        '</svg></button></div>';
    }

    // ---- Render grid ----
    function renderGrid() {
      const grid = document.getElementById('ccev-grid' + suffix);
      if (!grid) return;
      grid.innerHTML = COLORS.map(buildCardHTML).join('');
      bindCardEvents();
      bindHeartEvents();
    }

    // ---- Card click ----
    function bindCardEvents() {
      for (const card of document.querySelectorAll('#ccev-grid' + suffix + ' .ccev-card')) {
        card.addEventListener('click', handleCardClick);
        card.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleCardClick.call(card, e); }
        });
      }
    }

    function handleCardClick(e) {
      if (e.target.closest('.ccev-card__heart')) return;
      const slug = this.dataset ? this.dataset.colorSlug : e.currentTarget.dataset.colorSlug;
      const card = e.currentTarget || this;
      openModal(slug, card);
    }

    // ---- Heart events ----
    function bindHeartEvents() {
      for (const btn of document.querySelectorAll('#ccev-grid' + suffix + ' .ccev-card__heart')) {
        btn.addEventListener('click', e => { e.stopPropagation(); toggleFavorite(btn); });
        btn.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); toggleFavorite(btn); }
        });
      }
    }

    function toggleFavorite(btn) {
      const slug  = btn.dataset.slug;
      const name  = btn.dataset.name;
      const isFav = favorites.includes(slug);
      if (isFav) { favorites = favorites.filter(s => s !== slug); }
      else { favorites.push(slug); }
      saveFavorites(favorites);
      updateHeartUI(btn, !isFav, name);
      btn.style.transform = 'scale(0.92)';
      setTimeout(() => { btn.style.transform = 'scale(1)'; }, 120);
    }

    function updateHeartUI(btn, isNowFav, name) {
      btn.setAttribute('aria-pressed', isNowFav ? 'true' : 'false');
      btn.setAttribute('aria-label', isNowFav
        ? name + ' saved to favorites, click to remove'
        : 'Save ' + name + ' to favorites');
      const svg = btn.querySelector('svg');
      if (svg) {
        svg.setAttribute('fill',   isNowFav ? FOREST : 'none');
        svg.setAttribute('stroke', isNowFav ? '#FFFFFF' : FOREST);
      }
      btn.style.background  = isNowFav ? FOREST : '';
      btn.style.borderColor = isNowFav ? FOREST : '';
    }

    // ---- Open modal ----
    function openModal(slug, cardEl) {
      const color = COLORS.find(c => c.slug === slug);
      if (!color) return;
      openColorSlug = slug;
      sourceCardEl  = cardEl;

      for (const c of document.querySelectorAll('.ccev-card--selected')) c.classList.remove('ccev-card--selected');
      if (cardEl) cardEl.classList.add('ccev-card--selected');

      // Photo hero: backgroundImage (not backgroundColor)
      const previewPanel = document.getElementById('ccev-modal-preview-panel' + suffix);
      if (previewPanel) {
        previewPanel.style.backgroundImage    = 'url(' + color.image + ')';
        previewPanel.style.backgroundSize     = 'cover';
        previewPanel.style.backgroundPosition = 'center';
        previewPanel.setAttribute('aria-label', color.name + ' stain photo');
      }
      const badge = document.getElementById('ccev-modal-preview-badge' + suffix);
      if (badge) badge.textContent = color.family;
      const name = document.getElementById('ccev-modal-preview-name' + suffix);
      if (name)  name.textContent = color.name;

      // Mobile chip thumbnail
      const chipImg  = document.getElementById('ccev-modal-chip-img' + suffix);
      if (chipImg) { chipImg.src = color.image; chipImg.alt = color.name + ' thumbnail'; }
      const chipName = document.getElementById('ccev-modal-chip-name' + suffix);
      if (chipName) chipName.textContent = color.name;

      const h2 = document.getElementById('ccev-modal-h2' + suffix);
      if (h2)  h2.textContent = color.name;
      const desc = document.getElementById('ccev-modal-desc' + suffix);
      if (desc) desc.textContent = color.desc;
      const ctaEl = document.getElementById('ccev-modal-cta' + suffix);
      if (ctaEl) ctaEl.setAttribute('aria-label', 'Add ' + color.name + ' Evolve Soy Stain to cart');
      const pdpLink = document.getElementById('ccev-modal-pdp-link' + suffix);
      if (pdpLink) pdpLink.setAttribute('aria-label', 'View the full ' + color.name + ' product page');

      const scrim = document.getElementById('ccev-modal-scrim' + suffix);
      scrim.removeAttribute('hidden');
      scrim.setAttribute('aria-label', color.name + ' color detail');
      document.body.style.overflow = 'hidden';

      const closeBtn = document.getElementById('ccev-modal-close-desktop' + suffix);
      if (closeBtn) closeBtn.focus();
      resetPackTiles();
    }

    // ---- Pack tiles ----
    // Listeners are bound ONCE in init (see bindPackTiles call below).
    // resetPackTiles only resets the visual / aria state on each modal open.
    function resetPackTiles() {
      const tiles = document.querySelectorAll('#ccev-modal-body' + suffix + ' .ccev-modal__pack-card');
      tiles.forEach((tile, i) => {
        const first = i === 0;
        tile.classList.toggle('ccev-modal__pack-card--selected', first);
        tile.setAttribute('aria-checked', first ? 'true' : 'false');
        tile.setAttribute('tabindex', first ? '0' : '-1');
      });
    }

    // Returns the qty (1/2/3) currently selected in the pack grid.
    // Exposed so a future cart-add CTA can read it.
    function selectedPackQty() {
      const sel = document.querySelector(
        '#ccev-modal-body' + suffix + ' .ccev-modal__pack-card--selected'
      );
      const n = sel ? parseInt(sel.dataset.tierQty, 10) : 1;
      return (Number.isFinite(n) && n > 0) ? n : 1;
    }

    function bindPackTiles() {
      const tiles = document.querySelectorAll('#ccev-modal-body' + suffix + ' .ccev-modal__pack-card');
      const arr   = Array.from(tiles);
      arr.forEach((tile) => {
        tile.addEventListener('click', () => {
          arr.forEach((t) => {
            t.classList.remove('ccev-modal__pack-card--selected');
            t.setAttribute('aria-checked', 'false');
            t.setAttribute('tabindex', '-1');
          });
          tile.classList.add('ccev-modal__pack-card--selected');
          tile.setAttribute('aria-checked', 'true');
          tile.setAttribute('tabindex', '0');
        });
        tile.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tile.click(); return; }
          const idx = arr.indexOf(tile);
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            const next = arr[idx + 1];
            if (next) { next.focus(); next.click(); }
          }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            const prev = arr[idx - 1];
            if (prev) { prev.focus(); prev.click(); }
          }
        });
      });
    }

    // ---- Close modal ----
    function closeModal() {
      const scrim = document.getElementById('ccev-modal-scrim' + suffix);
      if (!scrim) return;
      scrim.setAttribute('hidden', '');
      document.body.style.overflow = '';
      for (const c of document.querySelectorAll('.ccev-card--selected')) c.classList.remove('ccev-card--selected');
      if (sourceCardEl) { sourceCardEl.focus(); sourceCardEl = null; }
      openColorSlug = null;
    }

    // ---- Focus trap ----
    function getFocusableEls() {
      const panel = document.getElementById('ccev-modal-panel' + suffix);
      if (!panel) return [];
      return Array.from(panel.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(el => !el.disabled && el.offsetParent !== null);
    }

    document.addEventListener('keydown', e => {
      const scrim = document.getElementById('ccev-modal-scrim' + suffix);
      if (!scrim || scrim.hasAttribute('hidden')) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Tab') {
        const focusable = getFocusableEls();
        if (!focusable.length) return;
        const first = focusable[0];
        const last  = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
        }
      }
    });

    // ---- Wire close + scrim click ----
    const scrimEl = document.getElementById('ccev-modal-scrim' + suffix);
    if (scrimEl) scrimEl.addEventListener('click', e => { if (e.target === e.currentTarget) closeModal(); });
    const closeDesktopEl = document.getElementById('ccev-modal-close-desktop' + suffix);
    if (closeDesktopEl) closeDesktopEl.addEventListener('click', closeModal);
    const closeMobileEl = document.getElementById('ccev-modal-close-mobile' + suffix);
    if (closeMobileEl) closeMobileEl.addEventListener('click', closeModal);

    // ---- Wire pack tiles once (selection + arrow-key navigation) ----
    bindPackTiles();

    // ---- Init ----
    renderGrid();
  }

  document.addEventListener('DOMContentLoaded', () => {
    const scripts = document.querySelectorAll('script[type="application/json"][id^="ccev-color-data-"]');
    for (const s of scripts) {
      const id = s.id.replace('ccev-color-data-', '');
      init(id);
    }
  });

  if (document.readyState !== 'loading') {
    const scripts = document.querySelectorAll('script[type="application/json"][id^="ccev-color-data-"]');
    for (const s of scripts) {
      const id = s.id.replace('ccev-color-data-', '');
      init(id);
    }
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-chart-satin-dreams"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const SECTION_ID = document.currentScript
    ? document.currentScript.closest('[id^="shopify-section-"]')
      ? document.currentScript.closest('[id^="shopify-section-"]').id.replace('shopify-section-', '')
      : null
    : null;

  function init(sectionId) {
    const suffix  = sectionId ? '-' + sectionId : '';
    const LS_KEY  = 'cc-favorites-v1';
    const FOREST  = '#2C3E2D';
    const FILTER_ALL = 'all';

    const dataEl = document.getElementById('ccsd-color-data' + suffix);
    if (!dataEl) return;
    const COLORS = JSON.parse(dataEl.textContent);

    // ---- localStorage favorites ----
    function loadFavorites() {
      try { const r = localStorage.getItem(LS_KEY); return r ? JSON.parse(r) : []; }
      catch (_) { return []; }
    }
    function saveFavorites(arr) {
      try { localStorage.setItem(LS_KEY, JSON.stringify(arr)); } catch (_) {}
    }
    let favorites = loadFavorites();

    // ---- State ----
    let activeFilter  = FILTER_ALL;
    let openColorSlug = null;
    let sourceCardEl  = null;

    // ---- Filter match ----
    function colorMatchesFilter(color, filter) {
      if (filter === FILTER_ALL) return true;
      if (filter === 'custom')   return false;
      const f = filter.replace(/&amp;/g, '&').replace(/&#38;/g, '&');
      return color.family === f || color.tags.includes(f);
    }

    // ---- Build card HTML ----
    function buildCardHTML(color) {
      const isFav    = favorites.includes(color.slug);
      const pressed  = isFav ? 'true' : 'false';
      const favLabel = isFav
        ? color.name + ' saved to favorites, click to remove'
        : 'Save ' + color.name + ' to favorites';
      return '<div class="ccsd-card" role="listitem" tabindex="0"' +
        ' aria-label="' + color.name + ', ' + color.family + ', ' + color.hex + '"' +
        ' data-color-slug="' + color.slug + '"' +
        ' data-color-family="' + color.family + '">' +
        '<div class="ccsd-card__inner">' +
        '<div class="ccsd-card__swatch" style="background:' + color.hex + ';">' +
        '<span class="ccsd-card__cat-badge">' + color.family + '</span>' +
        '</div>' +
        '<div class="ccsd-card__body">' +
        '<div class="ccsd-card__name">' + color.name + '</div>' +
        '</div></div>' +
        '<button class="ccsd-card__heart" type="button" tabindex="0"' +
        ' aria-pressed="' + pressed + '" aria-label="' + favLabel + '"' +
        ' data-slug="' + color.slug + '" data-name="' + color.name + '">' +
        '<svg width="11" height="11" viewBox="0 0 24 24"' +
        ' fill="' + (isFav ? FOREST : 'none') + '"' +
        ' stroke="' + (isFav ? '#FFFFFF' : FOREST) + '"' +
        ' stroke-width="2" aria-hidden="true">' +
        '<path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>' +
        '</svg></button></div>';
    }

    // ---- Render grid ----
    function renderGrid() {
      const grid = document.getElementById('ccsd-grid' + suffix);
      if (!grid) return;
      grid.innerHTML = COLORS.map(buildCardHTML).join('');
      applyFilter(activeFilter, false);
      bindCardEvents();
      bindHeartEvents();
    }

    // ---- Apply filter ----
    function applyFilter(filter, updatePills) {
      activeFilter = filter;
      const cards  = document.querySelectorAll('#ccsd-grid' + suffix + ' .ccsd-card');
      let shown = 0;
      for (const card of cards) {
        const color = COLORS.find(c => c.slug === card.dataset.colorSlug);
        const match = color && colorMatchesFilter(color, filter);
        card.classList.toggle('ccsd-card--hidden', !match);
        if (match) shown++;
      }
      const countEl  = document.getElementById('ccsd-count' + suffix);
      const footerEl = document.getElementById('ccsd-footer-count' + suffix);
      if (filter === FILTER_ALL) {
        if (countEl)  countEl.textContent  = 'Showing all 36 colors';
        if (footerEl) footerEl.textContent = 'Showing all 36 colors';
      } else if (filter === 'custom') {
        if (countEl)  countEl.textContent  = 'Custom color matching';
        if (footerEl) footerEl.textContent = 'Contact us for a custom color match';
      } else {
        const label = filter.replace(/&amp;/g, '&');
        if (countEl)  countEl.textContent  = shown + ' color' + (shown !== 1 ? 's' : '') + ' · ' + label;
        if (footerEl) footerEl.textContent = 'Showing ' + shown + ' of 36 colors';
      }
      if (updatePills !== false) updatePillStates(filter);
    }

    // ---- Update pill states ----
    function updatePillStates(activeValue) {
      const wrap = document.querySelector('.ccsd-wrap');
      if (!wrap) return;
      for (const pill of wrap.querySelectorAll('[data-filter]')) {
        const val   = pill.dataset.filter;
        const isAct = val === activeValue;
        pill.setAttribute('aria-pressed', isAct ? 'true' : 'false');
        if (val === 'custom') continue;
        pill.classList.toggle('ccsd-pill--active',   isAct);
        pill.classList.toggle('ccsd-pill--inactive', !isAct);
      }
    }

    // ---- Card click ----
    function bindCardEvents() {
      for (const card of document.querySelectorAll('#ccsd-grid' + suffix + ' .ccsd-card')) {
        card.addEventListener('click', handleCardClick);
        card.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleCardClick.call(card, e); }
        });
      }
    }

    function handleCardClick(e) {
      if (e.target.closest('.ccsd-card__heart')) return;
      const slug = this.dataset ? this.dataset.colorSlug : e.currentTarget.dataset.colorSlug;
      const card = e.currentTarget || this;
      openModal(slug, card);
    }

    // ---- Heart events ----
    function bindHeartEvents() {
      for (const btn of document.querySelectorAll('#ccsd-grid' + suffix + ' .ccsd-card__heart')) {
        btn.addEventListener('click', e => { e.stopPropagation(); toggleFavorite(btn); });
        btn.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); toggleFavorite(btn); }
        });
      }
    }

    function toggleFavorite(btn) {
      const slug  = btn.dataset.slug;
      const name  = btn.dataset.name;
      const isFav = favorites.includes(slug);
      if (isFav) { favorites = favorites.filter(s => s !== slug); }
      else { favorites.push(slug); }
      saveFavorites(favorites);
      updateHeartUI(btn, !isFav, name);
      btn.style.transform = 'scale(0.92)';
      setTimeout(() => { btn.style.transform = 'scale(1)'; }, 120);
    }

    function updateHeartUI(btn, isNowFav, name) {
      btn.setAttribute('aria-pressed', isNowFav ? 'true' : 'false');
      btn.setAttribute('aria-label', isNowFav
        ? name + ' saved to favorites, click to remove'
        : 'Save ' + name + ' to favorites');
      const svg = btn.querySelector('svg');
      if (svg) {
        svg.setAttribute('fill',   isNowFav ? FOREST : 'none');
        svg.setAttribute('stroke', isNowFav ? '#FFFFFF' : FOREST);
      }
      btn.style.background  = isNowFav ? FOREST : '';
      btn.style.borderColor = isNowFav ? FOREST : '';
    }

    // ---- Open modal ----
    function openModal(slug, cardEl) {
      const color = COLORS.find(c => c.slug === slug);
      if (!color) return;
      openColorSlug = slug;
      sourceCardEl  = cardEl;
      for (const c of document.querySelectorAll('.ccsd-card--selected')) c.classList.remove('ccsd-card--selected');
      if (cardEl) cardEl.classList.add('ccsd-card--selected');

      const previewPanel = document.getElementById('ccsd-modal-preview-panel' + suffix);
      if (previewPanel) {
        previewPanel.style.background = color.hex;
        previewPanel.setAttribute('aria-label', color.name + ' color preview');
      }
      const badge = document.getElementById('ccsd-modal-preview-badge' + suffix);
      if (badge) badge.textContent = color.family;
      const name = document.getElementById('ccsd-modal-preview-name' + suffix);
      if (name)  name.textContent = color.name;
      const hexEl = document.getElementById('ccsd-modal-preview-hex' + suffix);
      if (hexEl) hexEl.textContent = color.hex;

      const h2 = document.getElementById('ccsd-modal-h2' + suffix);
      if (h2)  h2.textContent = color.name;
      const desc = document.getElementById('ccsd-modal-desc' + suffix);
      if (desc) desc.textContent = color.desc;
      const ctaEl = document.getElementById('ccsd-modal-cta' + suffix);
      if (ctaEl) {
        ctaEl.setAttribute('aria-label', 'Add ' + color.name + ' Satin Dreams to cart');
        ctaEl.dataset.colorSlug    = color.slug;
        ctaEl.dataset.colorName    = color.name;
        ctaEl.dataset.colorVariant = color.variant_id || '';
      }
      const pdpLink = document.getElementById('ccsd-modal-pdp-link' + suffix);
      if (pdpLink) pdpLink.setAttribute('aria-label', 'View the full ' + color.name + ' product page');

      const scrim = document.getElementById('ccsd-modal-scrim' + suffix);
      scrim.removeAttribute('hidden');
      scrim.setAttribute('aria-label', color.name + ' color detail');
      document.body.style.overflow = 'hidden';

      const closeBtn = document.getElementById('ccsd-modal-close-desktop' + suffix);
      if (closeBtn) closeBtn.focus();
      resetPackTiles();
    }

    // ---- Modal CTA → add-to-cart + open cart drawer ----
    //
    // Behavior:
    //   1. If the active color has a `variant_id` in the JSON data block,
    //      POST /cart/add.js and call cart-drawer.renderContents() which
    //      auto-opens the drawer.
    //   2. If no variant_id is present (current state — variant mapping is
    //      a Sebastian step), fall back to navigating to the PDP with a
    //      ?color=<slug> query param so the PDP variant picker can preselect.
    function handleCtaAddToCart(e) {
      e.preventDefault();
      const btn      = e.currentTarget;
      const slug     = btn.dataset.colorSlug;
      const name     = btn.dataset.colorName;
      const variant  = btn.dataset.colorVariant;
      const pdpBase  = btn.dataset.pdpUrl || '/products/satin-dreams';

      // No variant ID yet → graceful fallback to PDP
      if (!variant) {
        window.location.href = pdpBase + (pdpBase.indexOf('?') >= 0 ? '&' : '?') + 'color=' + encodeURIComponent(slug);
        return;
      }

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      const qty = selectedPackQty();
      const fd = new FormData();
      fd.append('id', variant);
      fd.append('quantity', String(qty));
      if (cart && typeof cart.getSectionsToRender === 'function') {
        const sections = cart.getSectionsToRender().map(s => s.id);
        if (sections.length) {
          fd.append('sections', sections.join(','));
          fd.append('sections_url', window.location.pathname);
        }
      }

      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('ccsd-modal__cta-primary--loading');

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
      })
        .then(r => r.json())
        .then(response => {
          if (response.status) {
            console.error('[ccsd] cart add error:', response);
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response); // re-renders sections then calls .open()
          } else {
            window.location.href = rootUrl + 'cart';
          }
        })
        .catch(err => console.error('[ccsd] cart add fetch failed:', err))
        .finally(() => {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('ccsd-modal__cta-primary--loading');
        });
    }

    // ---- Pack tiles ----
    // Listeners are bound ONCE in init (see bottom of file). resetPackTiles
    // only resets the visual / aria state on each modal open — it never
    // rebinds listeners, which previously stacked up across opens.
    function resetPackTiles() {
      const tiles = document.querySelectorAll('#ccsd-modal-body' + suffix + ' .ccsd-modal__pack-card');
      tiles.forEach((tile, i) => {
        const first = i === 0;
        tile.classList.toggle('ccsd-modal__pack-card--selected', first);
        tile.setAttribute('aria-checked', first ? 'true' : 'false');
        tile.setAttribute('tabindex', first ? '0' : '-1');
      });
    }

    // Returns the qty (1/2/3) currently selected in the pack grid.
    function selectedPackQty() {
      const sel = document.querySelector(
        '#ccsd-modal-body' + suffix + ' .ccsd-modal__pack-card--selected'
      );
      const n = sel ? parseInt(sel.dataset.tierQty, 10) : 1;
      return (Number.isFinite(n) && n > 0) ? n : 1;
    }

    function bindPackTiles() {
      const tiles = document.querySelectorAll('#ccsd-modal-body' + suffix + ' .ccsd-modal__pack-card');
      const arr   = Array.from(tiles);
      arr.forEach((tile) => {
        tile.addEventListener('click', () => {
          arr.forEach((t) => {
            t.classList.remove('ccsd-modal__pack-card--selected');
            t.setAttribute('aria-checked', 'false');
            t.setAttribute('tabindex', '-1');
          });
          tile.classList.add('ccsd-modal__pack-card--selected');
          tile.setAttribute('aria-checked', 'true');
          tile.setAttribute('tabindex', '0');
        });
        tile.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tile.click(); return; }
          const idx = arr.indexOf(tile);
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            const next = arr[idx + 1];
            if (next) { next.focus(); next.click(); }
          }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            const prev = arr[idx - 1];
            if (prev) { prev.focus(); prev.click(); }
          }
        });
      });
    }

    // ---- Close modal ----
    function closeModal() {
      const scrim = document.getElementById('ccsd-modal-scrim' + suffix);
      if (!scrim) return;
      scrim.setAttribute('hidden', '');
      document.body.style.overflow = '';
      for (const c of document.querySelectorAll('.ccsd-card--selected')) c.classList.remove('ccsd-card--selected');
      if (sourceCardEl) { sourceCardEl.focus(); sourceCardEl = null; }
      openColorSlug = null;
    }

    // ---- Focus trap ----
    function getFocusableEls() {
      const panel = document.getElementById('ccsd-modal-panel' + suffix);
      if (!panel) return [];
      return Array.from(panel.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(el => !el.disabled && el.offsetParent !== null);
    }

    document.addEventListener('keydown', e => {
      const scrim = document.getElementById('ccsd-modal-scrim' + suffix);
      if (!scrim || scrim.hasAttribute('hidden')) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Tab') {
        const focusable = getFocusableEls();
        if (!focusable.length) return;
        const first = focusable[0];
        const last  = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
        }
      }
    });

    // ---- Wire close / scrim click ----
    const scrimEl = document.getElementById('ccsd-modal-scrim' + suffix);
    if (scrimEl) scrimEl.addEventListener('click', e => { if (e.target === e.currentTarget) closeModal(); });
    const closeDesktopEl = document.getElementById('ccsd-modal-close-desktop' + suffix);
    if (closeDesktopEl) closeDesktopEl.addEventListener('click', closeModal);

    // ---- Wire CTA: Add to cart + open cart drawer (or PDP fallback) ----
    const ctaWireEl = document.getElementById('ccsd-modal-cta' + suffix);
    if (ctaWireEl) ctaWireEl.addEventListener('click', handleCtaAddToCart);

    // ---- Wire pack tiles once (selection + arrow-key navigation) ----
    bindPackTiles();

    // ---- Wire filter pills ----
    const wrap = document.querySelector('.ccsd-wrap');
    if (wrap) {
      for (const pill of wrap.querySelectorAll('[data-filter]')) {
        pill.addEventListener('click', () => {
          const f = pill.dataset.filter;
          if (f === 'custom') {
            const url = wrap.closest('[id]')
              ? wrap.querySelector('a.ccsd-footer-band__link')
                ? wrap.querySelector('a.ccsd-footer-band__link').href
                : '#'
              : '#';
            window.location.href = url;
            return;
          }
          applyFilter(f);
        });
      }
    }

    // ---- Init ----
    renderGrid();
  }

  // Resolve section ID from the script tag's parent section
  document.addEventListener('DOMContentLoaded', () => {
    const scripts = document.querySelectorAll('script[type="application/json"][id^="ccsd-color-data-"]');
    for (const s of scripts) {
      const id = s.id.replace('ccsd-color-data-', '');
      init(id);
    }
  });

  // Also handle deferred/async section loading (theme editor)
  if (document.readyState !== 'loading') {
    const scripts = document.querySelectorAll('script[type="application/json"][id^="ccsd-color-data-"]');
    for (const s of scripts) {
      const id = s.id.replace('ccsd-color-data-', '');
      init(id);
    }
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-fsk-bundle"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initBundle(sectionEl) {
    const checkboxes   = sectionEl.querySelectorAll('[data-bundle-id]');
    const selfPriceEl  = sectionEl.querySelector('[data-bundle-self-price]');
    const totalEl      = sectionEl.querySelector('[data-bundle-total]');
    const labelEl      = sectionEl.querySelector('[data-bundle-label]');
    const saveEl       = sectionEl.querySelector('[data-bundle-save]');
    const ctaEl        = sectionEl.querySelector('[data-bundle-cta]');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function recalculate() {
      let total = 0;
      let checkedCount = 1; // always include this item

      // Base price from selected variant
      const selfPrice = parseInt(selfPriceEl?.dataset?.priceCents || '0', 10);
      total += selfPrice;

      checkboxes.forEach(function(cb) {
        if (cb.checked) {
          total += parseInt(cb.dataset.bundlePrice || '0', 10);
          checkedCount++;
        }
      });

      if (totalEl) totalEl.textContent = formatMoney(total);
      if (labelEl) {
        const defaultText = labelEl.dataset.defaultText || labelEl.textContent;
        labelEl.dataset.defaultText = defaultText;
        labelEl.textContent = defaultText + ' (' + checkedCount + ' items)';
      }
    }

    // Cache base price from DOM
    if (selfPriceEl) {
      const price = selfPriceEl.textContent.replace(/[^0-9]/g, '');
      selfPriceEl.dataset.priceCents = price;
    }

    checkboxes.forEach(function(cb) {
      cb.addEventListener('change', recalculate);
    });

    // Sync this-product price on variant change
    sectionEl.closest('body')?.addEventListener('gez:variant-changed', function(e) {
      const price = e.detail?.variant?.price;
      if (price && selfPriceEl) {
        selfPriceEl.dataset.priceCents = price;
        selfPriceEl.textContent = formatMoney(price);
        recalculate();
      }
    });

    recalculate();
  }

  document.querySelectorAll('[id^="shopify-section-"][class*="gez-fsk-bundle"]').forEach(initBundle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-fsk-gallery"] && !Shopify.designMode) return;
  try {
    
/**
 * gez-fsk-gallery.liquid
 * Handles:
 *   1. Dot / thumbnail click -> swap main image
 *   2. gez-favorite-button web component: localStorage toggle + aria-pressed
 */
(function () {
  'use strict';

  /* ---- Gallery image swap ---- */
  function initGallery(section) {
    const mainImg = section.querySelector('[data-gallery-main-img]');
    if (!mainImg) return;

    const dots   = section.querySelectorAll('[data-dot-idx]');
    const thumbs = section.querySelectorAll('[data-thumb-idx]');

    function swapImage(idx, src, srcset, alt, width, height) {
      if (!mainImg) return;
      mainImg.classList.add('is-loading');
      const newImg = new window.Image();
      newImg.onload = function () {
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        mainImg.alt = alt;
        if (width) mainImg.width = parseInt(width, 10);
        if (height) mainImg.height = parseInt(height, 10);
        mainImg.dataset.currentIdx = idx;
        mainImg.classList.remove('is-loading');
      };
      newImg.src = src;

      // Update dots
      dots.forEach(function (d) {
        const isActive = parseInt(d.dataset.dotIdx, 10) === idx;
        d.classList.toggle('is-active', isActive);
        d.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Update thumbs
      thumbs.forEach(function (t) {
        const isActive = parseInt(t.dataset.thumbIdx, 10) === idx;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const idx = parseInt(dot.dataset.dotIdx, 10);
        swapImage(idx, dot.dataset.imgSrc, null, dot.dataset.imgAlt, dot.dataset.imgWidth, dot.dataset.imgHeight);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const idx = parseInt(thumb.dataset.thumbIdx, 10);
        swapImage(idx, thumb.dataset.imgSrc, thumb.dataset.imgSrcset, thumb.dataset.imgAlt, thumb.dataset.imgWidth, thumb.dataset.imgHeight);
      });
    });
  }

  /* ---- gez-favorite-button web component ---- */
  if (!customElements.get('gez-favorite-button')) {
    class GezFavoriteButton extends HTMLElement {
      connectedCallback() {
        this.#setup();
      }

      #setup() {
        const productId = this.dataset.productId;
        const productTitle = this.dataset.productTitle || '';
        const productHandle = this.dataset.productHandle || '';

        // Restore state from localStorage
        try {
          const favorites = JSON.parse(localStorage.getItem('greenez_favorites_pending') || '[]');
          if (favorites.includes(productId)) this.#setActive(true);
        } catch (_) {}

        this.addEventListener('click', function () { this.#toggle(); }.bind(this));
        this.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.#toggle(); }
        }.bind(this));
      }

      #toggle() {
        const productId = this.dataset.productId;
        const productTitle = this.dataset.productTitle || '';
        const isFavorited = this.getAttribute('aria-pressed') === 'true';

        const newState = !isFavorited;
        this.#setActive(newState);

        // Persist to localStorage
        try {
          const favorites = JSON.parse(localStorage.getItem('greenez_favorites_pending') || '[]');
          const idx = favorites.indexOf(productId);
          if (newState && idx === -1) favorites.push(productId);
          if (!newState && idx > -1) favorites.splice(idx, 1);
          localStorage.setItem('greenez_favorites_pending', JSON.stringify(favorites));
        } catch (_) {}

        // Fire gez:favorite-toggled event (Klaviyo downstream)
        document.dispatchEvent(new CustomEvent('gez:favorite-toggled', {
          detail: { productId: productId, productTitle: productTitle, favorited: newState },
          bubbles: true
        }));
      }

      #setActive(active) {
        this.setAttribute('aria-pressed', active ? 'true' : 'false');
        this.classList.toggle('is-favorited', active);
        const outlineSvg = this.querySelector('.gez-fsk-gallery__heart-svg--outline');
        const filledSvg  = this.querySelector('.gez-fsk-gallery__heart-svg--filled');
        if (outlineSvg) outlineSvg.hidden = active;
        if (filledSvg)  filledSvg.hidden = !active;
        this.setAttribute('aria-label',
          active
            ? this.dataset.labelRemove || 'Remove from favorites'
            : this.dataset.labelAdd || 'Save to favorites'
        );
      }
    }

    customElements.define('gez-favorite-button', GezFavoriteButton);
  }

  /* ---- Init all gallery instances ---- */
  document.querySelectorAll('.gez-fsk-gallery[data-section-id]').forEach(initGallery);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-fsk-kit-items"] && !Shopify.designMode) return;
  try {
    
  class GezFskKitItems {
    constructor(root) {
      this.root = root;
      this.tabs = root.querySelectorAll('[data-kit-tab]');
      this.lists = root.querySelectorAll('[data-kit-list]');
      this._onTabClick = this._onTabClick.bind(this);
      this._onVariantChange = this._onVariantChange.bind(this);
      this._bindTabs();
      this._bindVariantSync();
    }

    _bindTabs() {
      this.tabs.forEach((t) => t.addEventListener('click', this._onTabClick));
    }

    _onTabClick(e) {
      const tab = e.currentTarget;
      if (tab.dataset.kitTab) this._setActive(tab.dataset.kitTab);
    }

    _bindVariantSync() {
      document.addEventListener('gez:variant-changed', this._onVariantChange);
    }

    _onVariantChange(e) {
      const title = (e.detail && e.detail.variantTitle) || '';
      this._setActive(/deluxe/i.test(title) ? 'deluxe' : 'half');
    }

    _setActive(kit) {
      this.tabs.forEach((t) => {
        const active = t.dataset.kitTab === kit;
        t.classList.toggle('gez-fsk-kit-items__tab--active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.lists.forEach((l) => {
        l.classList.toggle('gez-fsk-kit-items__list--active', l.dataset.kitList === kit);
      });
    }
  }

  function initGezFskKitItems(scope) {
    const root = scope || document;
    root.querySelectorAll('.gez-fsk-kit-items').forEach((el) => {
      if (el.dataset.gezKitItemsInit === 'true') return;
      new GezFskKitItems(el);
      el.dataset.gezKitItemsInit = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initGezFskKitItems());
  } else {
    initGezFskKitItems();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e && e.target) initGezFskKitItems(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-fsk-kit"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initKitTabs(sectionEl) {
    const tabs   = sectionEl.querySelectorAll('[data-fsk-kit-tab]');
    const panels = sectionEl.querySelectorAll('[data-fsk-kit-panel]');

    function showPanel(targetKey) {
      tabs.forEach(function(t) {
        const isActive = t.dataset.fskKitTab === targetKey;
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.classList.toggle('gez-fsk-kit__tab--active', isActive);
      });
      panels.forEach(function(p) {
        if (p.dataset.fskKitPanel === targetKey) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        showPanel(tab.dataset.fskKitTab);
      });
      tab.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const all = Array.from(tabs);
          const idx = all.indexOf(tab);
          const next = e.key === 'ArrowRight'
            ? all[(idx + 1) % all.length]
            : all[(idx - 1 + all.length) % all.length];
          next.focus();
          showPanel(next.dataset.fskKitTab);
        }
      });
    });

    // Sync with gez:variant-changed if the buybox variant name contains "deluxe"
    sectionEl.closest('body')?.addEventListener('gez:variant-changed', function(e) {
      const variantName = (e.detail?.variant?.title || '').toLowerCase();
      if (variantName.includes('deluxe')) {
        showPanel('deluxe');
      } else {
        showPanel('half');
      }
    });
  }

  document.querySelectorAll('[id^="shopify-section-"][class*="gez-fsk-kit"]').forEach(initKitTabs);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-pdp-sticky-tab-nav"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-tabnav-root]').forEach(function(nav) {
  if (!nav) return;

  var tabs = nav.querySelectorAll('[data-tabnav-anchor]');
  if (!tabs.length) return;

  /* Click: smooth-scroll to anchor */
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var anchor = tab.dataset.tabnavAnchor;
      var target = document.getElementById(anchor);
      if (!target) return;
      var navHeight = nav.offsetHeight + 8;
      var top = window.scrollY + target.getBoundingClientRect().top - navHeight;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  /* IntersectionObserver: mark active tab as section enters viewport */
  var tabMap = {};
  tabs.forEach(function(tab) { tabMap[tab.dataset.tabnavAnchor] = tab; });

  var anchors = Object.keys(tabMap);
  var observed = anchors.map(function(id) { return document.getElementById(id); }).filter(Boolean);

  if (!observed.length || !('IntersectionObserver' in window)) return;

  var navH = nav.offsetHeight;
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var id = entry.target.id;
        var activeTab = tabMap[id];
        if (!activeTab) return;
        tabs.forEach(function(t) {
          var isActive = t === activeTab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        /* Scroll active tab into view within nav */
        activeTab.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
    });
  }, {
    rootMargin: '-' + (navH + 40) + 'px 0px -60% 0px',
    threshold: 0
  });

  observed.forEach(function(el) { io.observe(el); });
  }); /* end querySelectorAll forEach */
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-sdea-hero"] && !Shopify.designMode) return;
  try {
    
/*
  gez-sdea-hero — Klaviyo Client API submit handler
  v4 2026-06-06

  No dependencies. Modern browsers only (fetch, async/await).
  Works for multiple section instances on the same page — all
  IDs are read from data attributes on the form element itself.
*/
(function () {
  'use strict';

  /**
   * Basic email regex. HTML5 type=email does the heavy lifting;
   * this is a secondary guard before the network request.
   * @param {string} value
   * @returns {boolean}
   */
  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim());
  }

  /**
   * Show an inline error message inside the feedback region.
   * @param {HTMLElement} feedbackEl
   * @param {string} message
   */
  function showError(feedbackEl, message) {
    feedbackEl.textContent = message;
    feedbackEl.className = 'gez-sdea-capture__feedback gez-sdea-capture__feedback--error';
  }

  /**
   * Clear the feedback region (neutral state).
   * @param {HTMLElement} feedbackEl
   */
  function clearFeedback(feedbackEl) {
    feedbackEl.textContent = '';
    feedbackEl.className = 'gez-sdea-capture__feedback';
  }

  /**
   * Replace the form with the inline success state.
   * The card heading and help text remain; only the <form> is swapped.
   * @param {HTMLFormElement} form
   */
  function showSuccess(form) {
    var successHtml =
      '<div class="gez-sdea-capture__success" role="status" aria-live="polite">' +
        '<p class="gez-sdea-capture__success-heading">' +
          'You’re on the list.' +
        '</p>' +
        '<p class="gez-sdea-capture__success-body">' +
          'We’ll email you the moment we open early access. ' +
          'Check your inbox for a quick confirmation.' +
        '</p>' +
      '</div>';
    form.insertAdjacentHTML('afterend', successHtml);
    form.remove();
  }

  /**
   * Set the submit button to the pending (in-flight) state.
   * @param {HTMLButtonElement} btn
   * @param {boolean} busy
   */
  function setButtonBusy(btn, busy) {
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    btn.disabled = busy;
  }

  /**
   * POST a subscription request to the Klaviyo Client API.
   * Returns the raw Response so callers can check .status.
   * @param {string} companyId
   * @param {string} listId
   * @param {string} email
   * @returns {Promise<Response>}
   */
  function subscribeToKlaviyo(companyId, listId, email) {
    var endpoint =
      'https://a.klaviyo.com/client/subscriptions/?company_id=' +
      encodeURIComponent(companyId);

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Summer Deck Early Access LP',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: listId }
          }
        }
      }
    };

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    });
  }

  /**
   * Wire up the submit handler for a single capture form.
   * @param {HTMLFormElement} form
   */
  function initForm(form) {
    var feedbackId = form.id.replace('gez-sdea-capture-form-', 'gez-sdea-feedback-');
    var feedbackEl = document.getElementById(feedbackId);
    var emailInput = form.querySelector('input[type="email"]');
    var submitBtn  = form.querySelector('button[type="submit"]');
    var honeypot   = form.querySelector('input[name="hp_field"]');

    if (!feedbackEl || !emailInput || !submitBtn) {
      return;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearFeedback(feedbackEl);

      /* Honeypot check — bot defence. Silently drop filled submissions. */
      if (honeypot && honeypot.value.length > 0) {
        return;
      }

      /* Read Klaviyo wiring from data attributes set by Liquid. */
      var listId    = (form.dataset.listId    || '').trim();
      var companyId = (form.dataset.companyId || '').trim();

      if (!listId || !companyId) {
        console.warn(
          '[gez-sdea-hero] Klaviyo wiring missing. ' +
          'Set klaviyo_list_id and klaviyo_company_id in the section settings.'
        );
        showError(
          feedbackEl,
          'Something went wrong. Try again, or email us.'
        );
        return;
      }

      var email = emailInput.value.trim();

      /* Client-side email validation. */
      if (!email || !isValidEmail(email)) {
        showError(feedbackEl, 'Please enter a valid email address.');
        emailInput.focus();
        return;
      }

      /* Set pending UI state. */
      setButtonBusy(submitBtn, true);

      subscribeToKlaviyo(companyId, listId, email)
        .then(function (response) {
          if (response.status === 202) {
            /* 202 Accepted — Klaviyo's documented success status. */
            showSuccess(form);
          } else {
            /* Any non-202 is treated as an error. */
            setButtonBusy(submitBtn, false);
            showError(
              feedbackEl,
              'Something went wrong. Try again, or email us.'
            );
          }
        })
        .catch(function () {
          /* Network failure or CORS issue. */
          setButtonBusy(submitBtn, false);
          showError(
            feedbackEl,
            'Something went wrong. Try again, or email us.'
          );
        });
    });
  }

  /**
   * Find and initialise all capture forms on the page.
   * Runs on DOMContentLoaded for initial load, and on
   * shopify:section:load so the editor re-render re-wires correctly.
   */
  function initAllForms() {
    var forms = document.querySelectorAll('form[id^="gez-sdea-capture-form-"]');
    forms.forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllForms);
  } else {
    initAllForms();
  }

  /* Re-wire after theme editor section re-render. */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var forms = section.querySelectorAll('form[id^="gez-sdea-capture-form-"]');
    forms.forEach(initForm);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-sdea-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initScrollToForm() {
    const triggers = document.querySelectorAll('[data-sdea-scroll-to-form]');
    if (!triggers.length) return;

    for (const trigger of triggers) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        const capture = document.querySelector('.gez-sdea-capture');
        if (!capture) return;

        capture.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // Focus the first focusable element inside the capture card
        const focusable = capture.querySelector(
          'input, button, [tabindex]:not([tabindex="-1"]), .klaviyo-form-[class]'
        );
        if (focusable) {
          setTimeout(function () { focusable.focus(); }, 300);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollToForm);
  } else {
    initScrollToForm();
  }

  // Re-init on theme editor section load
  document.addEventListener('shopify:section:load', initScrollToForm);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-shared-atc-cluster"] && !Shopify.designMode) return;
  try {
    
/**
 * gez-shared-atc-cluster.liquid
 * - Listens for `gez:variant-changed` from buybox or picker
 * - Handles its own ATC form submit
 * - Handles qty stepper
 */
(function () {
  'use strict';

  class GezAtcCluster extends HTMLElement {
    #variantData = [];
    #abortController = null;
    #fetchController = null;

    connectedCallback() {
      const jsonEl = this.querySelector('[data-atc-variant-json]');
      if (jsonEl) {
        try { this.#variantData = JSON.parse(jsonEl.textContent); } catch (_) {}
      }

      this.#abortController = new AbortController();
      const sig = { signal: this.#abortController.signal };

      document.addEventListener('gez:variant-changed', this.#onVariantChanged.bind(this), sig);

      const form = this.querySelector('[data-atc-form]');
      if (form) form.addEventListener('submit', this.#handleSubmit.bind(this), sig);

      this.querySelector('[data-atc-qty-minus]')?.addEventListener('click', () => this.#stepQty(-1), sig);
      this.querySelector('[data-atc-qty-plus]')?.addEventListener('click', () => this.#stepQty(1), sig);
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#fetchController?.abort();
    }

    #stepQty(delta) {
      const input = this.querySelector('[data-atc-qty]');
      if (!input) return;
      const next = Math.min(
        parseInt(input.max || 99, 10),
        Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + delta)
      );
      input.value = next;
    }

    #onVariantChanged(event) {
      const { variant } = event.detail || {};
      if (!variant) return;
      this.#applyVariant(variant);
    }

    #applyVariant(variant) {
      const vidInput = this.querySelector('[data-atc-variant-id]');
      if (vidInput) vidInput.value = variant.id;

      const priceEl = this.querySelector('[data-atc-price]');
      const compareEl = this.querySelector('[data-atc-compare]');
      if (priceEl) priceEl.textContent = this.#formatMoney(variant.price);
      if (compareEl) {
        compareEl.textContent = variant.compare_at_price
          ? this.#formatMoney(variant.compare_at_price)
          : '';
        compareEl.hidden = !variant.compare_at_price || variant.compare_at_price <= variant.price;
      }

      const btn = this.querySelector('[data-atc-btn]');
      const label = this.querySelector('[data-atc-btn-label]');
      const price = this.querySelector('[data-atc-btn-price]');
      if (btn) {
        btn.disabled = !variant.available;
        btn.classList.toggle('is-sold-out', !variant.available);
        if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (price) price.textContent = this.#formatMoney(variant.price);
      }
    }

    async #handleSubmit(event) {
      event.preventDefault();
      const form = event.target;
      const btn = this.querySelector('[data-atc-btn]');
      const spinner = this.querySelector('[data-atc-spinner]');

      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      if (spinner) spinner.hidden = false;

      this.#fetchController?.abort();
      this.#fetchController = new AbortController();

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          signal: this.#fetchController.signal
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const item = await response.json();
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { item },
          bubbles: true
        }));
      } catch (err) {
        if (err.name !== 'AbortError') console.error('[GezAtcCluster] error:', err);
      } finally {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        if (spinner) spinner.hidden = true;
      }
    }

    #formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD'
        }).format(amount);
      } catch (_) {
        return `$${amount}`;
      }
    }
  }

  if (!customElements.get('gez-atc-cluster')) {
    customElements.define('gez-atc-cluster', GezAtcCluster);
  }

  document.querySelectorAll('.gez-atc[data-section-id]').forEach(el => {
    if (el.tagName.toLowerCase() !== 'gez-atc-cluster') {
      const ce = document.createElement('gez-atc-cluster');
      for (const attr of el.attributes) ce.setAttribute(attr.name, attr.value);
      ce.append(...el.childNodes);
      el.replaceWith(ce);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-shared-buybox"] && !Shopify.designMode) return;
  try {
    
/**
 * gez-shared-buybox.liquid
 * Handles:
 *   1. Kit size card click -> variant match -> price/ATC/stock update
 *   2. Pack quantity tier card click -> sets hidden qty input + dispatches qty change
 *   3. ATC form submit -> /cart/add.js -> dispatches cart:item-added
 *   4. Delivery countdown: counts down to cutoff_hour (local time), shows delivery range
 *   5. Listens for gez:variant-changed from external sources (sticky-atc)
 *
 * PACK QUANTITY (option a wiring):
 *   On kit card or tier card click, the hidden input data-bbox-qty-hidden is updated
 *   to the selected tier qty. The form POSTs qty to /cart/add.js normally.
 *   Each tier card carries data-tier-discount-code — Sebastian wires a Shopify
 *   automatic quantity discount with that code to provide the per-ea price reduction.
 *   No client-side price fabrication: displayed per-ea and total prices are from
 *   block.settings (admin-authored at block authoring time, matching Shopify discount tiers).
 */
(function () {
  'use strict';

  /* ---- Utilities ---- */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
    } catch (_) {
      return '$' + amount;
    }
  }

  /* ---- Delivery countdown ---- */
  function initDelivery(container) {
    const el = container.querySelector('[data-delivery]');
    if (!el) return;

    const cutoffHour = parseInt(el.dataset.cutoffHour, 10) || 14;
    const minDays = parseInt(el.dataset.minDays, 10) || 2;
    const maxDays = parseInt(el.dataset.maxDays, 10) || 6;
    const countdownEl = el.querySelector('[data-delivery-countdown]');
    const rangeEl = el.querySelector('[data-delivery-range]');

    function addBusinessDays(date, days) {
      let d = new Date(date);
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        const dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return d;
    }

    function formatDate(date) {
      return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    }

    function update() {
      const now = new Date();
      const cutoff = new Date(now);
      cutoff.setHours(cutoffHour, 0, 0, 0);

      let baseDate = now;
      if (now >= cutoff) {
        baseDate = new Date(now);
        baseDate.setDate(baseDate.getDate() + 1);
      }

      const minDelivery = addBusinessDays(baseDate, minDays);
      const maxDelivery = addBusinessDays(baseDate, maxDays);

      if (rangeEl) {
        rangeEl.textContent = formatDate(minDelivery) + ' - ' + formatDate(maxDelivery);
      }

      if (countdownEl) {
        if (now < cutoff) {
          const diff = cutoff - now;
          const h = Math.floor(diff / 3600000);
          const m = Math.floor((diff % 3600000) / 60000);
          countdownEl.textContent = h + 'h ' + String(m).padStart(2, '0') + 'm';
        } else {
          countdownEl.textContent = '';
        }
      }
    }

    update();
    setInterval(update, 60000);
  }

  /* ---- Kit size card interaction ---- */
  function initKitCards(container, variantData, sectionId) {
    const kitGrid = container.querySelector('[data-kit-card]');
    if (!kitGrid) return;

    const allCards = container.querySelectorAll('[data-kit-card]');

    allCards.forEach(function (card) {
      card.addEventListener('click', function () {
        const variantId = parseInt(card.dataset.variantId, 10);
        if (!variantId) return;

        const matched = variantData.find(function (v) { return v.id === variantId; });
        if (!matched) return;

        // Update active state on all cards
        allCards.forEach(function (c) {
          c.classList.remove('is-active');
          const chk = c.querySelector('[data-kit-card] .gez-bbox__kit-check, .gez-bbox__kit-check');
          if (chk) chk.classList.remove('is-visible');
        });
        card.classList.add('is-active');
        const checkEl = card.querySelector('.gez-bbox__kit-check');
        if (checkEl) checkEl.classList.add('is-visible');

        // Check the radio
        const radio = card.querySelector('[data-kit-radio]');
        if (radio) radio.checked = true;

        // Apply variant
        applyVariant(container, matched, sectionId);

        // Update URL without reload
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* ---- Pack quantity tier interaction ---- */
  function initQtyTierCards(container) {
    const allTierCards = container.querySelectorAll('[data-qty-card]');
    if (!allTierCards.length) return;

    allTierCards.forEach(function (card) {
      card.addEventListener('click', function () {
        allTierCards.forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');

        const radio = card.querySelector('[data-tier-radio]');
        if (radio) radio.checked = true;

        const qty = parseInt(card.dataset.qty, 10) || 1;
        const qtyInput = container.querySelector('[data-bbox-qty-hidden]');
        if (qtyInput) qtyInput.value = qty;

        // OQ-1 resolved 2026-05-15: Shopify automatic quantity discounts fire
        // by cart rules (Admin > Discounts > Buy X Get Y). No discount code needs
        // to be submitted with the form — Shopify applies the discount automatically
        // at checkout based on cart quantity. The data-tier-discount-code attribute
        // is a reference label for Sebastian when creating the Shopify discount rule.
      });
    });
  }

  /* ---- Apply variant (price, ATC, stock update) ---- */
  function applyVariant(container, variant, sectionId) {
    // Hidden variant id
    const vidInput = container.querySelector('[data-bbox-variant-id]');
    if (vidInput) vidInput.value = variant.id;

    // Price
    const priceEl = container.querySelector('[data-bbox-price]');
    const compareEl = container.querySelector('[data-bbox-compare]');
    const saveEl = container.querySelector('[data-bbox-save]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEl.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
      compareEl.hidden = !hasCompare;
      if (saveEl) {
        if (hasCompare) {
          const pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          const amt = formatMoney(variant.compare_at_price - variant.price);
          saveEl.textContent = 'SAVE ' + pct + '% - ' + amt + ' OFF';
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    }

    // ATC
    const atcBtn = container.querySelector('[data-bbox-atc]');
    const atcPrice = container.querySelector('[data-bbox-atc-price]');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.classList.toggle('is-sold-out', !variant.available);
      if (atcPrice) atcPrice.textContent = formatMoney(variant.price);
    }

    // Stock row
    const stockDot = container.querySelector('.gez-bbox__stock-dot');
    const stockText = container.querySelector('[data-stock-text]');
    if (stockDot) stockDot.classList.toggle('gez-bbox__stock-dot--out', !variant.available);
    if (stockText) {
      stockText.innerHTML = variant.available
        ? '<b>In stock</b> · ships within 24h'
        : 'Out of stock';
    }

    // Propagate to sticky-atc and other listeners
    document.dispatchEvent(new CustomEvent('gez:variant-changed', {
      detail: { sectionId: sectionId, variant: variant },
      bubbles: true
    }));
  }

  /* ---- ATC form submit ---- */
  function initForm(container, sectionId) {
    const form = container.querySelector('[data-bbox-form]');
    if (!form) return;

    let fetchController = null;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      const atcBtn = container.querySelector('[data-bbox-atc]');
      const spinner = container.querySelector('.gez-bbox__atc-spinner');
      if (atcBtn) { atcBtn.disabled = true; atcBtn.classList.add('is-loading'); }
      if (spinner) spinner.hidden = false;

      if (fetchController) fetchController.abort();
      fetchController = new AbortController();

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        signal: fetchController.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function (item) {
          document.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: { item: item },
            bubbles: true
          }));
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') {
            /* eslint-disable no-console */
            console.error('[GezBuybox] ATC error:', err);
          }
        })
        .finally(function () {
          const currentVariantId = container.querySelector('[data-bbox-variant-id]');
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.classList.remove('is-loading');
          }
          if (spinner) spinner.hidden = true;
        });
    });
  }

  /* ---- Bootstrap all buybox instances ---- */
  document.querySelectorAll('.gez-bbox[data-section-id]').forEach(function (el) {
    const sectionId = el.dataset.sectionId;
    const jsonEl = el.querySelector('[data-bbox-variant-json]');
    let variantData = [];
    if (jsonEl) {
      try { variantData = JSON.parse(jsonEl.textContent); } catch (_) {}
    }

    initDelivery(el);
    initKitCards(el, variantData, sectionId);
    initQtyTierCards(el);
    initForm(el, sectionId);

    // Listen for external variant-changed (e.g. sticky-atc)
    document.addEventListener('gez:variant-changed', function (event) {
      if (event.detail && event.detail.sectionId !== sectionId && event.detail.variant) {
        applyVariant(el, event.detail.variant, sectionId);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-shared-hero-gallery"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-hgal-root]').forEach(function(root) {
  if (!root) return;

  var slides = root.querySelectorAll('[data-hgal-slide]');
  var dots = root.querySelectorAll('[data-hgal-dot]');
  var thumbs = root.querySelectorAll('[data-hgal-thumb]');
  var current = 0;

  function goTo(idx) {
    if (idx < 0 || idx >= slides.length) return;
    slides[current].classList.remove('is-active');
    slides[current].setAttribute('aria-hidden', 'true');
    if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected', 'false'); }
    if (thumbs[current]) { thumbs[current].classList.remove('is-active'); thumbs[current].setAttribute('aria-pressed', 'false'); }
    current = idx;
    slides[current].classList.add('is-active');
    slides[current].setAttribute('aria-hidden', 'false');
    if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected', 'true'); }
    if (thumbs[current]) {
      thumbs[current].classList.add('is-active');
      thumbs[current].setAttribute('aria-pressed', 'true');
      thumbs[current].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() { goTo(parseInt(dot.dataset.hgalDot, 10)); });
  });

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() { goTo(parseInt(thumb.dataset.hgalThumb, 10)); });
  });

  /* Touch swipe on mobile */
  var touchStartX = 0;
  var frameEl = root.querySelector('[data-hgal-frame]');
  if (frameEl) {
    frameEl.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    frameEl.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        if (dx < 0 && current < slides.length - 1) goTo(current + 1);
        else if (dx > 0 && current > 0) goTo(current - 1);
      }
    }, { passive: true });
  }

  /* Variant change: swap to variant featured image */
  document.addEventListener('gez:variant-changed', function(e) {
    if (!e.detail || !e.detail.variant || !e.detail.variant.featured_image) return;
    var featId = e.detail.variant.featured_image.id;
    slides.forEach(function(slide, i) {
      var img = slide.querySelector('img');
      if (!img) return;
      /* Compare by matching src against variant image URL pattern */
      if (img.src && img.src.indexOf(featId) !== -1) goTo(i);
    });
  });
  }); /* end querySelectorAll forEach */
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-shared-sticky-atc"] && !Shopify.designMode) return;
  try {
    
/**
 * gez-shared-sticky-atc.liquid
 * - Shows/hides bar via IntersectionObserver on buybox sentinel
 * - Listens for `gez:variant-changed` from buybox; updates price + ATC state
 * - Handles compact swatch radio changes -> dispatches `gez:variant-changed`
 * - Handles ATC form submit
 */
(function () {
  'use strict';

  class GezStickyAtc extends HTMLElement {
    #variantData = [];
    #abortController = null;
    #fetchController = null;
    #observer = null;

    connectedCallback() {
      const jsonEl = this.querySelector('[data-satc-variant-json]');
      if (jsonEl) {
        try { this.#variantData = JSON.parse(jsonEl.textContent); } catch (_) {}
      }

      this.#abortController = new AbortController();
      const sig = { signal: this.#abortController.signal };

      document.addEventListener('gez:variant-changed', this.#onVariantChanged.bind(this), sig);
      this.addEventListener('change', this.#handleSwatchChange.bind(this), sig);

      const form = this.querySelector('[data-satc-form]');
      if (form) form.addEventListener('submit', this.#handleSubmit.bind(this), sig);

      this.#initObserver();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#fetchController?.abort();
      this.#observer?.disconnect();
    }

    #initObserver() {
      // Watch the buybox section for scroll-away. Fallback: always show after 200px scroll.
      const sentinel = document.querySelector('[data-bbox-sentinel]')
        || document.querySelector('.gez-shared-buybox')
        || document.querySelector('.gez-bbox');

      if (sentinel && 'IntersectionObserver' in window) {
        this.#observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              this.#setVisible(!entry.isIntersecting);
            }
          },
          { rootMargin: '0px 0px -80px 0px', threshold: 0 }
        );
        this.#observer.observe(sentinel);
      } else {
        // Fallback: show after 200px scroll
        const onScroll = () => this.#setVisible(window.scrollY > 200);
        window.addEventListener('scroll', onScroll, {
          passive: true,
          signal: this.#abortController.signal
        });
      }
    }

    #setVisible(visible) {
      if (visible) {
        this.removeAttribute('hidden');
        this.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => this.classList.add('is-visible'));
      } else {
        this.classList.remove('is-visible');
        this.setAttribute('aria-hidden', 'true');
        const afterHide = () => {
          if (!this.classList.contains('is-visible')) this.setAttribute('hidden', '');
        };
        this.addEventListener('transitionend', afterHide, { once: true });
      }
    }

    #handleSwatchChange(event) {
      const input = event.target;
      if (!input.dataset.satcOption) return;

      const idx = parseInt(input.dataset.satcOption, 10);

      // Update active state on compact swatches
      const axis = input.closest('[data-satc-swatch-axis]');
      if (axis) {
        for (const wrap of axis.querySelectorAll('.gez-satc__swatch-wrap')) {
          const radio = wrap.querySelector('input');
          if (radio === input) {
            wrap.classList.add('is-active');
            wrap.querySelector('.gez-satc__swatch')?.classList.add('is-active');
          } else {
            wrap.classList.remove('is-active');
            wrap.querySelector('.gez-satc__swatch')?.classList.remove('is-active');
          }
        }
      }

      const matched = this.#matchVariant(input, idx);
      if (matched) {
        this.#applyVariant(matched);
        // Propagate to buybox and atc-cluster
        document.dispatchEvent(new CustomEvent('gez:variant-changed', {
          detail: {
            sectionId: this.dataset.sectionId,
            variant: matched
          },
          bubbles: true
        }));
      }
    }

    #matchVariant(changedInput, changedIdx) {
      // Collect current selections across all sticky swatch axes
      const options = [];
      for (const axis of this.querySelectorAll('[data-satc-swatch-axis]')) {
        const axisIdx = parseInt(axis.dataset.satcSwatchAxis, 10);
        const checked = axis.querySelector('input[type="radio"]:checked');
        if (checked) options[axisIdx] = checked.value;
      }
      // For non-swatch axes, use the variant data's current selection
      const currentVid = parseInt(this.dataset.currentVariant, 10);
      const currentV = this.#variantData.find(v => v.id === currentVid);
      if (currentV) {
        for (let i = 0; i < 3; i++) {
          if (options[i] === undefined) options[i] = currentV[`option${i + 1}`];
        }
      }

      return this.#variantData.find(v =>
        options.slice(0, this.#optionCount()).every((opt, i) => v[`option${i + 1}`] === opt)
      ) || null;
    }

    #optionCount() {
      // Infer from variant data
      if (!this.#variantData.length) return 1;
      const v = this.#variantData[0];
      if (v.option3) return 3;
      if (v.option2) return 2;
      return 1;
    }

    #onVariantChanged(event) {
      const { variant, sectionId } = event.detail || {};
      // Ignore events we dispatched ourselves
      if (sectionId === this.dataset.sectionId) return;
      if (variant) this.#applyVariant(variant);
    }

    #applyVariant(variant) {
      this.dataset.currentVariant = variant.id;

      const vidInput = this.querySelector('[data-satc-variant-id]');
      if (vidInput) vidInput.value = variant.id;

      const priceEl = this.querySelector('[data-satc-price]');
      if (priceEl) priceEl.textContent = this.#formatMoney(variant.price);

      const btn = this.querySelector('[data-satc-btn]');
      const label = this.querySelector('[data-satc-btn-label]');
      if (btn) {
        btn.disabled = !variant.available;
        btn.classList.toggle('is-sold-out', !variant.available);
        if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      // Update active swatch in compact row
      for (const axis of this.querySelectorAll('[data-satc-swatch-axis]')) {
        const axisIdx = parseInt(axis.dataset.satcSwatchAxis, 10);
        const matchVal = variant[`option${axisIdx + 1}`];
        for (const wrap of axis.querySelectorAll('.gez-satc__swatch-wrap')) {
          const radio = wrap.querySelector('input');
          const active = radio?.value === matchVal;
          wrap.classList.toggle('is-active', active);
          wrap.querySelector('.gez-satc__swatch')?.classList.toggle('is-active', active);
          if (radio) radio.checked = active;
        }
      }
    }

    async #handleSubmit(event) {
      event.preventDefault();
      const form = event.target;
      const btn = this.querySelector('[data-satc-btn]');
      const spinner = this.querySelector('[data-satc-spinner]');

      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      if (spinner) spinner.hidden = false;

      this.#fetchController?.abort();
      this.#fetchController = new AbortController();

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          signal: this.#fetchController.signal
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const item = await response.json();
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { item },
          bubbles: true
        }));
      } catch (err) {
        if (err.name !== 'AbortError') console.error('[GezStickyAtc] error:', err);
      } finally {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        if (spinner) spinner.hidden = true;
      }
    }

    #formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD'
        }).format(amount);
      } catch (_) {
        return `$${amount}`;
      }
    }
  }

  if (!customElements.get('gez-sticky-atc')) {
    customElements.define('gez-sticky-atc', GezStickyAtc);
  }

  document.querySelectorAll('.gez-satc[data-section-id]').forEach(el => {
    if (el.tagName.toLowerCase() !== 'gez-sticky-atc') {
      const ce = document.createElement('gez-sticky-atc');
      for (const attr of el.attributes) ce.setAttribute(attr.name, attr.value);
      ce.append(...el.childNodes);
      el.replaceWith(ce);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gez-shared-variant-picker"] && !Shopify.designMode) return;
  try {
    
/**
 * gez-shared-variant-picker.liquid
 * Handles radio-based option selection -> variant match -> dispatches
 * a `gez:variant-changed` custom event for buybox / sticky-atc to react.
 *
 * No external dependencies. Progressive enhancement: the form still submits
 * without JS because inputs are native radio elements inside a form.
 */
(function () {
  'use strict';

  class GezVariantPicker extends HTMLElement {
    #sectionId = '';
    #productId = '';
    #variantData = [];
    #abortController = null;

    connectedCallback() {
      this.#sectionId = this.dataset.sectionId;
      this.#productId = this.dataset.productId;

      // Parse variant JSON from the associated form element if present.
      const formEl = document.getElementById(`product-form-${this.#sectionId}`);
      if (formEl) {
        const variantInput = formEl.querySelector('[data-variant-json]');
        if (variantInput) {
          try {
            this.#variantData = JSON.parse(variantInput.textContent);
          } catch (_) { /* malformed JSON — fall back to URL-based lookup */ }
        }
      }

      this.#abortController = new AbortController();
      this.addEventListener('change', this.#handleChange.bind(this), {
        signal: this.#abortController.signal
      });
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #handleChange(event) {
      const input = event.target;
      if (!input.classList.contains('gez-vpick__swatch-input') &&
          !input.classList.contains('gez-vpick__pill-input')) return;

      this.#updateSelectedLabel(input);
      const matched = this.#matchVariant();
      if (matched) this.#dispatch(matched);
    }

    #updateSelectedLabel(changedInput) {
      const axis = changedInput.closest('[data-option-index]');
      if (!axis) return;
      const selectedEl = axis.querySelector('[id$="-selected"]');
      if (selectedEl) selectedEl.textContent = changedInput.value;

      // Update active class on swatch/pill wraps within this axis.
      const wrapClass = changedInput.classList.contains('gez-vpick__swatch-input')
        ? 'gez-vpick__swatch-wrap'
        : 'gez-vpick__pill-wrap';
      for (const wrap of axis.querySelectorAll(`.${wrapClass}`)) {
        const radio = wrap.querySelector('input[type="radio"]');
        if (radio === changedInput) {
          wrap.classList.add('is-active');
          wrap.querySelector('.gez-vpick__swatch, .gez-vpick__pill')?.classList.add('is-active');
        } else {
          wrap.classList.remove('is-active');
          wrap.querySelector('.gez-vpick__swatch, .gez-vpick__pill')?.classList.remove('is-active');
        }
      }
    }

    #matchVariant() {
      const options = [];
      for (const axis of this.querySelectorAll('[data-option-index]')) {
        const checked = axis.querySelector('input[type="radio"]:checked');
        if (checked) options.push(checked.value);
      }
      if (!options.length) return null;

      // Match against cached variant data first.
      if (this.#variantData.length) {
        return this.#variantData.find(v => {
          return options.every((opt, i) => v[`option${i + 1}`] === opt);
        }) || null;
      }

      // Fallback: match against Shopify's product.variants JS object if injected.
      const productVariants = window[`GezProductVariants_${this.#productId}`];
      if (productVariants) {
        return productVariants.find(v =>
          options.every((opt, i) => v.options[i] === opt)
        ) || null;
      }

      return null;
    }

    #dispatch(variant) {
      this.dispatchEvent(new CustomEvent('gez:variant-changed', {
        detail: {
          sectionId: this.#sectionId,
          productId: this.#productId,
          variant
        },
        bubbles: true
      }));
    }
  }

  if (!customElements.get('gez-variant-picker')) {
    customElements.define('gez-variant-picker', GezVariantPicker);
  }

  // Upgrade: wrap the .gez-vpick div as the custom element's content root.
  // The section renders a plain div; JS upgrades to custom element via dataset.
  document.querySelectorAll('.gez-vpick[data-section-id]').forEach(el => {
    if (el.tagName.toLowerCase() !== 'gez-variant-picker') {
      const ce = document.createElement('gez-variant-picker');
      for (const attr of el.attributes) ce.setAttribute(attr.name, attr.value);
      ce.append(...el.childNodes);
      el.replaceWith(ce);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
